import { OnlineExamActionTypes } from "./onlineExam.types";
import axios from "axios";
import { PAGE_SIZE } from "res/constants";


export const getOnlineExamStart = () => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_START,
});

export const getOnlineExamSuccess = (data) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_SUCCESS,
  payload: data,
});

export const getOnlineExamFailure = (error) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_FAILURE,
  payload: error,
});

export const resetOnlineExamState = (error) => ({
  type: OnlineExamActionTypes.RESET_ONLINEEXAM_STATE,
  payload: error,
});

export const setShowNextQuestion = (isShow) => ({
  type: OnlineExamActionTypes.SET_SHOW_NEXT_QUESTION,
  payload: isShow
})

export const setAnswer = (payload) => ({
  type: OnlineExamActionTypes.SET_ANSWER,
  payload: payload
})

///Get Details ByID

export const setExamCounter = (counter) => ({
  type: OnlineExamActionTypes.SET_EXAM_COUNTER,
  payload: counter,
});
export const setOnlineExam = (onlineExamID) => ({
  type: OnlineExamActionTypes.SET_ONLINE_EXAM,
  payload: onlineExamID,
});
export const setCurrentQuestionIndex = (questionIndex) => ({
  type: OnlineExamActionTypes.SET_CURRENT_QUESTION_INDEX,
  payload: questionIndex,
});

export const getOnlineExamDetailStart = () => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_DETAIL_START,
});

export const getOnlineExamDetailSuccess = (data, examID) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_DETAIL_SUCCESS,
  payload: { examData: data, examID },
});

export const getOnlineExamDetailFailure = (error) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_DETAIL_FAILURE,
  payload: error,
});

///Get Result ByID

export const getOnlineExamResultDetailStart = () => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_START,
});

export const getOnlineExamResultDetailSuccess = (data) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_SUCCESS,
  payload: data,
});

export const getOnlineExamResultDetailFailure = (error) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_FAILURE,
  payload: error,
});

///Get OnlineExamResult Detail ByID

export const getOnlineExamResultStart = () => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_START,
});

export const getOnlineExamResultSuccess = (data) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_SUCCESS,
  payload: data,
});

export const getOnlineExamResultWarning = (data) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_WARNING,
  payload: data,
});

export const getOnlineExamResultFailure = (error) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_FAILURE,
  payload: error,
});

///Get Answer ByID

export const getOnlineExamAnswerStart = () => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_ANSWER_START,
});

export const getOnlineExamAnswerSuccess = (data) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_ANSWER_SUCCESS,
  payload: data,
});

export const getOnlineExamAnswerFailure = (error) => ({
  type: OnlineExamActionTypes.FETCH_ONLINEEXAM_ANSWER_FAILURE,
  payload: error,
});


///Get Results

export const getResultsStart = () => ({
  type: OnlineExamActionTypes.FETCH_RESULTS_START,
});

export const getResultsSuccess = (data) => ({
  type: OnlineExamActionTypes.FETCH_RESULTS_SUCCESS,
  payload: data,
});

export const getResultsFailure = (error) => ({
  type: OnlineExamActionTypes.FETCH_RESULTS_FAILURE,
  payload: error,
});
export const resetResultLoadMore = () => ({
  type: OnlineExamActionTypes.RESET_RESULTS_LOADMORE,
});


///Post Exam

export const postExamStart = () => ({
  type: OnlineExamActionTypes.FETCH_POST_EXAM_START,
});

export const postExamSuccess = (data) => ({
  type: OnlineExamActionTypes.FETCH_POST_EXAM_SUCCESS,
  payload: data,
});

export const postExamFailure = (error) => ({
  type: OnlineExamActionTypes.FETCH_POST_EXAM_FAILURE,
  payload: error,
});

//Reset Errors
export const resetErrors = (error) => ({
  type: OnlineExamActionTypes.RESET_ERROR,
})

//Current Page
export const setCurrentPage = (currentPage) => ({
  type: OnlineExamActionTypes.SET_CURRENT_PAGE,
  payload: currentPage,

});

//ExamType
export const setExamType = (examMode) => ({
  type: OnlineExamActionTypes.SET_EXAM_MODE,
  payload: examMode,

});
//uploading file status
export const setIsUploadingFile = (isLoading) => ({
  type: OnlineExamActionTypes.SET_UPLOADING_FILE,
  payload: isLoading,

});

//reset plan offset
export const resetPlanOffset = () => ({
  type: OnlineExamActionTypes.RESET_PLAN_OFFSET,

});
//reset result offset
export const resetResultOffset = () => ({
  type: OnlineExamActionTypes.RESET_RESULT_OFFSET,

});


export const getOnlineExamStartAsync = ({
  studentID, semesterID
}) => {
  return (dispatch, getState) => {
    const { onlineExam } = getState();
    dispatch(getOnlineExamStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/OnlineExamResults/GetCurrent?semesterId=${semesterID}&pageIndex=${onlineExam ? onlineExam.offset : 1}&pageSize=${PAGE_SIZE}&studentId=${studentID}`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getOnlineExamSuccess(response.data.data));
        } else {
          dispatch(getOnlineExamFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getOnlineExamFailure(error?.response?.data?.message || 'خطا'))
        throw new Error(`url=api/parent/v1.0/OnlineExamResults/GetCurrent?semesterId=${semesterID}&pageIndex=${onlineExam ? onlineExam.offset : 1}&pageSize=${PAGE_SIZE}&studentId=${studentID}&error:${error}`)

      });
  };
};



export const getOnlineExamDetailStartAsync = ({
  studentID, onlineExamID, semesterID
}) => {
  return (dispatch, getState) => {
    dispatch(getOnlineExamDetailStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/OnlineExamResults/${semesterID}/${studentID}/${onlineExamID}/StartExam`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getOnlineExamDetailSuccess(response.data.data, onlineExamID));
        } else {
          dispatch(getOnlineExamDetailFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getOnlineExamDetailFailure(error?.response?.data?.message || 'خطا'))
      });
  };
};


export const getOnlineExamResultDetailStartAsync = ({
  studentID, onlineExamID, semesterID
}) => {
  return (dispatch, getState) => {
    const { onlineExam } = getState();
    dispatch(getOnlineExamDetailStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/OnlineExamResults/${semesterID}/${studentID}/${onlineExamID}/Details`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getOnlineExamDetailSuccess(response.data.data, onlineExamID));
        } else {
          dispatch(getOnlineExamDetailFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getOnlineExamDetailFailure(error?.response?.data?.message || 'خطا'))
      });
  };
};


export const getResultsStartAsync = ({
  studentID, semesterID, isShowArchived = false
}) => {
  return (dispatch, getState) => {
    const { onlineExam } = getState();
    dispatch(getResultsStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/OnlineExamResults/GetOldExam?semesterId=${semesterID}&pageIndex=${onlineExam.resultOffset}&pageSize=${PAGE_SIZE}&studentId=${studentID}&isShowArchived=${isShowArchived}`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getResultsSuccess(response.data.data));
        } else {
          dispatch(getResultsFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getResultsFailure(error?.response?.data?.message || 'خطا'))
        throw new Error(`url=api/parent/v1.0/OnlineExamResults/GetOldExam?semesterId=${semesterID}&pageIndex=${onlineExam.resultOffset}&pageSize=${PAGE_SIZE}&studentId=${studentID}&isShowArchived=${isShowArchived}&error:${error}`)

      });
  };
};

export const postOnlineExamStartAsync = ({
  studentID, onlineExamID, body, onSuccess, semesterID, isExpired = false, onError, isAutomaticSended
}) => {
  return (dispatch, getState) => {
    dispatch(postExamStart());
    axios
      .post(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/OnlineExamResults/${semesterID}/${studentID}/${onlineExamID}/FinishExam?isExpired=${isExpired}&isAutomaticSended=${isAutomaticSended}`, body, {
        timeout: 30000
      }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(postExamSuccess());
          onSuccess()
        } else {
          dispatch(postExamFailure(response.data.message))
          onError?.();
          throw new Error(response.data.message)
        }
      })
      .catch((error) => {
          onError?.();
        dispatch(postExamFailure(error?.response?.data?.message || 'خطا'))
        throw new Error(`studentID:${studentID}&url=/api/parent/v1.0/OnlineExamResults/${semesterID}/${studentID}/${onlineExamID}/FinishExam?isExpired=${isExpired}&error:${error?.response?.data?.message || error}&body=${JSON.stringify(body)}`)
      });
  };
};

export const getOnlineExamResultStartAsync = ({
  studentID, onlineExamID, semesterID
}) => {
  return (dispatch, getState) => {
    const { onlineExam } = getState();
    dispatch(getOnlineExamResultStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/OnlineExamResults/${semesterID}/${studentID}/${onlineExamID}/WorkBook`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          if (response.data.data) {
            dispatch(getOnlineExamResultSuccess(response.data.data));
          } else {
            dispatch(getOnlineExamResultWarning(response.data.message));
          }
        } else {
          dispatch(getOnlineExamResultFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getOnlineExamResultFailure(error?.response?.data?.message || 'خطا'))
      });
  };
};
